import script from "./Wrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./Wrapper.vue?vue&type=script&setup=true&lang=js"

import "./Wrapper.vue?vue&type=style&index=0&id=7546e742&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7546e742"]])

export default __exports__